import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, TPriceStrategy } from 'types';
import { defaultPriceStrategy } from 'appConstants/dishes';

export type TTypeOfModalWindow = Nullable<'defaultTranslationIsEmpty'>;

export interface ICreatePortionState {
	nameOfPortion: string;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurant: Nullable<string>;
	nameOfDish: string;
	dishId: string;
	isCreatedOnPos: boolean;
	price: Nullable<number>;
	priceStrategy: TPriceStrategy;
	externalId: string;
	isProtectedFromSync: boolean;
	isDisabled: boolean;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: string[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createPortionInitialState: ICreatePortionState = {
	nameOfPortion: '',
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDSelectedRestaurant: null,
	nameOfDish: '',
	dishId: '',
	isCreatedOnPos: false,
	price: null,
	priceStrategy: defaultPriceStrategy,
	externalId: '',
	isProtectedFromSync: false,
	isDisabled: false,
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	typeOfModalWindow: null,
};

export interface ICreatePortionContext extends ICreatePortionState {
	changeNameOfPortion(value: string): void;
	changePrice(value: Nullable<number>): void;
	changePriceStrategy(value: TPriceStrategy): void;
	changeExternalId(value: string): void;
	generateUniqueExternalId(): void;
	toggleIsProtectedFromSync(): void;
	toggleIsDisabled(): void;
	// setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: string[]): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const CreatePortionContext = createContext<ICreatePortionContext>({
	changeNameOfPortion: () => undefined,
	changePrice: () => undefined,
	changePriceStrategy: () => undefined,
	changeExternalId: () => undefined,
	generateUniqueExternalId: () => undefined,
	toggleIsProtectedFromSync: () => undefined,
	toggleIsDisabled: () => undefined,
	// setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...createPortionInitialState,
});
